"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Items = _styledComponents.default.div.withConfig({
  displayName: "Grid__Items",
  componentId: "sc-1qnydxk-0"
})(["display:flex;flex-wrap:wrap;list-style-type:none;height:100%;"]);

const Item = _styledComponents.default.div.withConfig({
  displayName: "Grid__Item",
  componentId: "sc-1qnydxk-1"
})(["display:flex;justify-content:center;align-items:center;width:calc(100% / ", ");cursor:pointer;", ";", " &:hover{background:#eee;}"], p => p.cols, p => p.theme.transition, p => p.selected && (0, _styledComponents.css)(["background:#eee;"]));

const selectItem = (idx, onSelect) => () => {
  onSelect(idx);
};

const Grid = ({
  className,
  select,
  items,
  cols,
  onSelect
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: className
}, /*#__PURE__*/_react.default.createElement(Items, null, items.map((item, idx) => /*#__PURE__*/_react.default.createElement(Item, {
  key: idx,
  cols: cols,
  selected: select === idx,
  onClick: selectItem(idx, onSelect)
}, item))));

var _default = (0, _styledComponents.default)(Grid).withConfig({
  displayName: "Grid",
  componentId: "sc-1qnydxk-2"
})(["border:1px solid #eee;"]);

exports.default = _default;